import React from 'react';
import { Button, Form, Header, Segment, Input } from 'semantic-ui-react';
import axios from 'axios';
import 'react-widgets/dist/css/react-widgets.css';
import 'react-datepicker/dist/react-datepicker.css';

axios.defaults.xsrfHeaderName = "X-XSRF-TOKEN";
axios.defaults.xsrfCookieName = 'XSRF-TOKEN';
axios.defaults.withCredentials = true;
//axios.defaults.crossDomain = true;


export default class PropertyFilter extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            organizationalUnitId: null,
            street: null,
            placeName: null,
            municipality: null,
            canton: null,
            entity: null,
            country: null,
            propertyName: null,
            rightType: null,
            usefulSurface: null,
            teachingArea: null,
            disabledAccess: null,
            active: null,
        };

        this.handleInputChange = this.handleInputChange.bind(this);
        this.handleDateChange = this.handleDateChange.bind(this);
        this.onFilterData = this.onFilterData.bind(this);
    }

    onFilterData() {
        const propertyFilterData = {
            organizationalUnit: this.state.organizationalUnitId,
            propertyName: this.state.propertyName,
            rightType: this.state.rightType,
            usefulSurface: this.state.usefulSurface,
            teachingArea: this.state.teachingArea,
            disabledAccess: this.state.disabledAccess,
            street: this.state.street === '' ? null : this.state.street,
            place: this.state.placeName,
            municipality: this.state.municipality,
            canton: this.state.canton,
            entity: this.state.entity,
            country: this.state.country,
            status: null,
            active: null,
        };

        this.props.onFilterData(propertyFilterData);
    }


    handleInputChange(event, { name, value }) {
        this.setState({
            [name]: value,
        });
    }

    handleDateChange(name, date) {
        this.setState({
            [name]: date
        });
    }


    render() {
        return (
            <Segment raised>
                <Form>
                    <Header as="h4">Adresa</Header>
                    {this.props.organizationalUnitsPrivilege &&
                    <Form.Group widths="4">
                        <Form.Dropdown clearable
                            label="Organizaciona jedinica"
                            placeholder="Organizaciona jedinica"
                            value={this.state.organizationalUnitId}
                            onChange={this.handleInputChange}
                            name="organizationalUnitId"
                            options={this.props.organizationalUnits}
                            search
                            fluid
                            selection
                        />
                    </Form.Group>
                    }
                    <Form.Group widths="equal">
                        <Form.Field
                            control={Input}
                            label="Ulica"
                            name="street"
                            value={this.state.street}
                            onChange={this.handleInputChange}
                            placeholder="Unesite ulicu"
                        />
                        <Form.Field
                            control={Input}
                            label="Mjesto"
                            name="placeName"
                            value={this.state.placeName}
                            onChange={this.handleInputChange}
                            placeholder="Unesite naziv mjesta"
                        />

                        <Form.Dropdown clearable
                            label="Opština"
                            placeholder="Opština"
                            value={this.state.municipality}
                            name="municipality"
                            onChange={this.handleInputChange}
                            options={this.props.lookups.municipalities}
                            search
                            fluid
                            selection
                        />

                        <Form.Dropdown clearable
                            label="Kanton"
                            placeholder="Kanton"
                            value={this.state.canton}
                            name="canton"
                            onChange={this.handleInputChange}
                            options={this.props.lookups.cantons}
                            search
                            fluid
                            selection
                        />

                        <Form.Dropdown clearable
                            label="Entitet"
                            placeholder="Entitet"
                            value={this.state.entity}
                            name="entity"
                            onChange={this.handleInputChange}
                            options={this.props.lookups.entities}
                            search
                            fluid
                            selection
                        />

                        <Form.Dropdown clearable
                            label="Država"
                            placeholder="Država"
                            value={this.state.country}
                            name="country"
                            onChange={this.handleInputChange}
                            options={this.props.lookups.countries}
                            search
                            fluid
                            selection
                        />
                    </Form.Group>

                    <Form.Group widths="equal">
                        <Form.Field
                            control={Input}
                            label="Naziv imovine"
                            name="propertyName"
                            value={this.state.propertyName}
                            onChange={this.handleInputChange}
                            placeholder="Naziv imovine"
                        />

                        <Form.Dropdown clearable
                            label="Tip prava"
                            placeholder="Tip prava"
                            value={this.state.rightType}
                            name="rightType"
                            onChange={this.handleInputChange}
                            options={this.props.lookups.rightTypes}
                            search
                            fluid
                            selection
                        />
                        <Form.Field
                            control={Input}
                            label="Korisna površina (m²)"
                            name="usefulSurface"
                            type="number"
                            value={this.state.usefulSurface}
                            onChange={this.handleInputChange}
                            placeholder="Korisna površina"
                        />

                        <Form.Field
                            control={Input}
                            label="Površina za učenje (m²)"
                            name="teachingArea"
                            type="number"
                            value={this.state.teachingArea}
                            onChange={this.handleInputChange}
                            placeholder="Površina za učenje"
                        />

                        <Form.Dropdown clearable
                            label="Pristup invalidima"
                            placeholder="Pristup invalidima"
                            value={this.state.disabledAccess}
                            name="disabledAccess"
                            onChange={this.handleInputChange}
                            options={this.props.lookups.disabledAccesses}
                            search
                            fluid
                            selection
                        />
                    </Form.Group>
                    <Button
                        color="blue"
                        onClick={() => this.onFilterData()}
                    >
                    Filtriraj
                    </Button>
                    <Button
                        basic
                        color="blue"
                        onClick={this.props.cancelFilter}
                    >
                        Odustani
                    </Button>
                </Form>
            </Segment>
        );
    }
}



// WEBPACK FOOTER //
// ./src/views/Assets/Property/PropertyFilter.js